<template>
  <div
    v-editable="blok"
    class="EmployeeCardGroup"
    :class="[desktopWidth('full'), {
      'desk:text-left': blok.cards.length < 4 && blok.cards.length > 0
    }]"
  >
    <div class="layout-container empty:hidden type-headline-xl py-8 mb-4 leading-single">
      {{ blok.headline }}
    </div>

    <div
      class="layout-container grid grid-cols-2 gap-8 tabletPortrait:grid-cols-3 tabletPortrait:gap-12 desk:grid-cols-4 desk:gap-16"
    >
      <EmployeeCard
        v-for="card in blok.cards"
        :key="card._uid"
        :blok="card"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { EmployeeCardGroupProps } from '~/constants/types/storyblok';
import useVisualAppearancePlugin from '~/composeables/useVisualAppearancePlugin';

const props = defineProps<{
  blok: EmployeeCardGroupProps,
}>();

const { desktopWidth } = useVisualAppearancePlugin(props);
</script>

<style scoped lang="postcss">
</style>
